"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tile = void 0;
class Tile {
    constructor(position, mine, opened, flagged = false) {
        this.position = position;
        this.mine = mine;
        this.opened = opened;
        this.flagged = flagged;
    }
    isMine() {
        return this.mine;
    }
    isOpen() {
        return this.opened;
    }
    isFlagged() {
        return this.flagged;
    }
    calculateNumber(neighbors) {
        if (this.contentCache) {
            return this.contentCache;
        }
        if (this.flagged) {
            return 'flag';
        }
        if (!this.isOpen()) {
            return 'closed';
        }
        if (this.isMine()) {
            return 'mine';
        }
        const num = neighbors.reduce((acc, cur) => acc + (cur.isMine() ? 1 : 0), 0);
        if (num < 0 || num > 8) {
            throw new TypeError("A tile can't have more than eight neighbors");
        }
        this.contentCache = num;
        return num;
    }
    open() {
        if (this.flagged) {
            return;
        }
        this.opened = true;
    }
    flag() {
        if (this.opened) {
            return;
        }
        this.flagged = true;
    }
    getPosition() {
        return this.position;
    }
    hasCachedContent() {
        return this.contentCache;
    }
}
exports.Tile = Tile;
//# sourceMappingURL=Tile.js.map